import { j as r } from "../../../../../../../../jsx-runtime.BREq8dyb.js";
import { Tooltip as p, Box as a } from "@mui/joy";
import { memo as x } from "react";
import { useDataset as v } from "../../../../../../contexts/DatasetContext/DatasetContext.js";
import "../../../../../../contexts/FeatureContext/FeatureContext.js";
import "../../../../../../contexts/FileContext/FileContext.js";
import "../../../../../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../../../../../contexts/NavigatorContext/NavigatorContext.js";
import { useOptions as h } from "../../../../../../contexts/OptionsContext/OptionsContext.js";
import "../../../../../../contexts/SchemaContext/SchemaContext.js";
import "../../../../../../contexts/TypificationContext/TypificationContext.js";
import "../../../../../../contexts/WorkerContext/WorkerContext.js";
const j = x(({
  column: {
    id: m
  },
  row: {
    original: {
      row: e = void 0
    } = {}
  },
  renderedCellValue: s
}) => {
  const {
    mappedColumns: d
  } = h(), {
    autofixReport: f,
    validationReport: u
  } = v();
  if (e !== void 0 && m !== void 0) {
    let o = parseInt(m), n, l;
    if (d.indexOf(o) !== -1 && (o = d.indexOf(o), n = u?.report.columns.find(({
      column: i
    }) => i === o)?.recordedErrors?.find(({
      location: {
        row: i,
        column: c
      }
    }) => i === e && c === o), l = f?.report.columnModifications.find(({
      column: i
    }) => i === o)?.recordedModifications?.find(({
      location: {
        row: i,
        column: c
      }
    }) => i === e && c === o)), n) {
      const {
        message: t
      } = n;
      return /* @__PURE__ */ r.jsx(p, { disableFocusListener: !0, disableTouchListener: !0, placement: "top-start", title: t, children: /* @__PURE__ */ r.jsx(a, { sx: {
        color: "danger.500",
        fontWeight: 600,
        overflow: "hidden",
        textOverflow: "ellipsis"
      }, children: s }) });
    }
    if (l) {
      const {
        previousValue: t
      } = l;
      return /* @__PURE__ */ r.jsx(p, { disableFocusListener: !0, disableTouchListener: !0, placement: "top-start", title: t, children: /* @__PURE__ */ r.jsx(a, { sx: {
        color: "neutral.500",
        fontWeight: 600,
        overflow: "hidden",
        textOverflow: "ellipsis"
      }, children: s }) });
    }
  }
  return s;
});
j.displayName = "Cell";
export {
  j as default
};
//# sourceMappingURL=Cell.js.map
